import React from 'react';
const ProfilePage = React.lazy(() => import("app/pages/profile"));
export const settingsRoutes = [
  {
    path: '/profile',
    element: <ProfilePage />,
  },
];
